import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Details } from "@/components/Details";
import { Speakers } from "@/components/Speakers";
import { Worship } from "@/components/Worship";
import { FeeInfo } from "@/components/FeeInfo";
import { RegistrationForm } from "@/components/RegistrationForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

const LandingPage = () => {
  const [theme, toggleTheme] = useTheme();

  const scrollToRegister = () => {
    document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-body min-h-screen bg-[#0B1233] text-[#F8F5E8]">
      <Navbar
        lang="en"
        onRegister={scrollToRegister}
        theme={theme}
        onToggleTheme={toggleTheme}
      />
      <main>
        <Hero lang="en" onRegister={scrollToRegister} />
        <Details lang="en" />
        <Speakers lang="en" />
        <Worship lang="en" />
        <FeeInfo lang="en" onRegister={scrollToRegister} />
        <RegistrationForm />
        <Contact lang="en" />
      </main>
      <Footer lang="en" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
